import 'bootstrap'
// console.log(bootstrap)


$(function() {
    $('[data-toggle="tooltip"]').tooltip() 
})

// Toggle filter box
$('.box').each(function(index) {
    var elBox = $(this);
    var elTitle = $(this).find('.box-title');
    var elIcon = elTitle.find('a.plus-minus-toggle');
    var elContent = elTitle.closest('.box').find('.box-content');

    if (elBox.hasClass('open')) {
        elIcon.removeClass('collapsed');
        elTitle.removeClass('closed').addClass('open');
        elContent.show();
    }
    if (elBox.hasClass('closed')) {
        elIcon.addClass('collapsed');
        elTitle.removeClass('open').addClass('closed');
        elContent.hide();
    }
});

$('body').on('click', '.box-title', function(event) {
    var elTitle = $(this)
    var elIcon = elTitle.find('a.plus-minus-toggle');
    var elContent = elTitle.closest('.box').find('.box-content')
    elTitle.toggleClass('open');
    elTitle.toggleClass('closed');
    elTitle.parent().toggleClass('open');
    elTitle.parent().toggleClass('closed');
    elIcon.toggleClass('collapsed');
    elContent.slideToggle();
    event.stopPropagation();
});


//////////////////
// WEBPACK FOOTER
// ./src/js/main.js
// module id = 2
// module chunks = 0